import { render, staticRenderFns } from "./SalesBySeller.vue?vue&type=template&id=1cff53fc"
import script from "./SalesBySeller.vue?vue&type=script&lang=js"
export * from "./SalesBySeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports